import { API_BASE } from './config';
import { getAccessToken } from './token-store';

/**
 * Resolve an API-relative media path (`/api/v2/media/vehicles/…`) into something an `<img>`
 * can load from the bidder origin (a separate Pages origin — ADR 0020).
 *
 * The access token rides the query because a browser cannot attach an `Authorization` header to
 * an `<img src>` — the same handshake the realtime route uses. **Every vehicle photo needs it**
 * since [ADR 0027](../../../../docs/adr/0027-login-gated-auction-surface.md): media is
 * session-gated, so a tokenless URL is a 401 rather than a public photo. The `token ? …` branch
 * therefore no longer expresses a public path; it only keeps the helper honest for a caller that
 * runs before the access token has hydrated. The server answers `private`, so no shared cache
 * retains a per-session body.
 */
export function mediaSrc(path: string | null | undefined): string | undefined {
  if (!path) return undefined;
  const origin = API_BASE.replace(/\/api\/v2$/, '');
  const token = getAccessToken();
  return `${origin}${path}${token ? `?token=${encodeURIComponent(token)}` : ''}`;
}
